import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "@/contexts/ContentContext";
import { iconFor } from "@/lib/icons";
import { trackCta } from "@/lib/analytics";

export const AwsaiSection = () => {
    const { content } = useContent();
    const a = content.awsai;

    return (
        <section id="awsai" data-testid="awsai-section" className="bg-white py-24 lg:py-28 relative">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                    <div className="lg:col-span-6">
                        <p className="label-eyebrow">{a.eyebrow}</p>
                        <h2 data-testid="awsai-title" className="mt-4 font-display font-semibold text-slate-900 text-3xl sm:text-4xl lg:text-[42px] leading-[1.1] tracking-tight">{a.title}</h2>
                        <p className="mt-3 text-lg text-teal-700 font-display font-medium">{a.subtitle}</p>

                        <div className="mt-7 space-y-5 text-[15px] text-slate-600 font-body leading-relaxed">
                            <p>{a.intro_paragraph_1}</p>
                            <p>{a.intro_paragraph_2}</p>
                        </div>

                        <div className="mt-9 flex flex-wrap gap-3">
                            <a
                                href={a.primary_cta_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="awsai-cta-start-assessment"
                                onClick={() => trackCta("awsai_click", { source: "awsai_section", label: "start_assessment" })}
                                className="btn-base btn-primary"
                            >
                                {a.primary_cta_label}
                                <ArrowUpRight className="w-4 h-4" />
                            </a>
                            <a
                                href={a.secondary_cta_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="awsai-cta-request-report"
                                onClick={() => trackCta("awsai_click", { source: "awsai_section", label: "request_professional_report" })}
                                className="btn-base btn-secondary"
                            >
                                <ArrowUpRight className="w-4 h-4" />
                                {a.secondary_cta_label}
                            </a>
                        </div>

                        {a.note && (
                            <div className="mt-6 inline-flex items-start gap-3 border-l-2 border-teal-600 pl-4 py-2 max-w-xl bg-slate-50">
                                <p className="text-[13px] text-slate-600 font-body leading-relaxed">{a.note}</p>
                            </div>
                        )}
                    </div>

                    <div className="lg:col-span-6">
                        <div className="border border-slate-200 bg-slate-50 p-7 lg:p-9">
                            <div className="flex items-center justify-between">
                                <p className="label-eyebrow !text-slate-500">AWSAI assesses</p>
                                <span className="text-[12px] uppercase tracking-[0.18em] text-slate-400">{(a.dimensions || []).length} Dimensions</span>
                            </div>
                            <h3 className="mt-3 font-display text-2xl font-semibold text-slate-900">Readiness dimensions</h3>
                            <div data-testid="awsai-dimensions-grid" className="mt-6 grid sm:grid-cols-2 gap-3">
                                {(a.dimensions || []).map((d, i) => {
                                    const Icon = iconFor(d.icon);
                                    return (
                                        <div key={`${d.label}-${i}`} className="dim-pill" data-testid={`awsai-dimension-${i + 1}`}>
                                            <Icon strokeWidth={1.5} className="w-4 h-4 text-teal-600" />
                                            <span>{d.label}</span>
                                        </div>
                                    );
                                })}
                            </div>
                            {a.footer_text && (<p className="mt-7 text-[13px] text-slate-500 leading-relaxed">{a.footer_text}</p>)}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AwsaiSection;
